import type { PropsWithChildren } from 'react'
import type { StatusTone } from '@/types/status'

interface StatusBadgeProps extends PropsWithChildren {
  tone: StatusTone
}

export function StatusBadge({ tone, children }: StatusBadgeProps) {
  return <span className={`status-badge status-badge--${tone}`}>{children}</span>
}
